class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
         
    });

    const cartDrawer = document.querySelector('cart-drawer');
    const subtotalElement = document.querySelector('.totals__subtotal-value');
    const priceAttributeValue = subtotalElement.getAttribute('price');
    const priceValue = parseFloat(priceAttributeValue);
    
     cartLink.addEventListener('click', () => {
    //    const blackTest = document.querySelector('.black_test');
    //    const cartDrawerPreloader = document.querySelector('.cart-drawer-preloader');
    // const cartCountBubble = document.querySelector('.cart-count-bubble');
    // const cartDrawerPreloader2 = document.querySelector('.preloader2');
    // const headerCart = document.querySelector('.header__cart');
    // const cartDrawer = document.querySelector('.cart-drawer');
    //     blackTest.style.top = '0';
    //    blackTest.addEventListener('click', () => {
    //   blackTest.style.top = '100000px';
    // });
    // if (!cartDrawerPreloader.classList.contains('active')) {
    //   cartDrawerPreloader.classList.add('active');
      
    //   console.log('addA');
    // }
    //   if (cartDrawerPreloader.classList.contains('fade-out')) {
    //     cartDrawerPreloader.classList.remove('fade-out');
    //     // cartDrawerPreloader.style.background = '#12121280';
    //   }
    //   cartDrawerPreloader.style.display = 'flex';
    //   cartDrawerPreloader2.style.zIndex = '9999';
       
      const cartCountTest = document.querySelector('.header__cart-count');
       
      const CartDraw = document.querySelector('cart-drawer');

       if (cartCountTest) {
         
      const cartCountText = cartCountTest.textContent;
      const cartCountNumber = parseInt(cartCountText);
            
       if (cartCountTest && cartCountNumber > 0)  {
           let refreshCart = document.querySelector('.refreshCart');
            refreshCart.click();
         } 
           else {
           CartDraw.classList.add('active'); 
         cartDrawerPreloader.classList.add('fade-out');
         } 
         
       } else {
         
         CartDraw.classList.add('active'); 

         cartDrawerPreloader.classList.add('fade-out');
         
       }
          
             const openSamplesInterval = setInterval(() => {
             openSamples();
               },500);
            setTimeout(() => {
              clearInterval(openSamplesInterval);
            },1000);
             

     });
  }

  open(triggeredBy) {
    
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    const htmlOver = document.querySelector('html');
    htmlOver.setAttribute('style', 'overflow: hidden !important;');
      
    setTimeout(async () => {
      
      this.classList.add('animate', 'active');

                     });
    // if (getCookie('coupon') == 'applied') {
    //   document.querySelector('.accordionBTN').textContent = 'Your promo code was sucessfully applied. All prices will be recalculated on the checkout page.';
    // }    

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
       deleteTwoMess();

    setTimeout(async () => {
    var currentURL = window.location.href;
var parts = currentURL.split('/');
var trimmedLanguageNow = parts[3].slice(0,2);  
    
    let url;

    const maxLimitCartP = document.querySelector('.maxLimitCart_P');

    switch (trimmedLanguageNow) {
        case 'fr':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/FR_Sandra_reviewed_9_04.json?v=1712638887';
        if(maxLimitCartP) {
            maxLimitCartP.textContent = 'MONTANT DE LA COMMANDE LIMITÉ À 1500€';
        }
            break;
        case 'de':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/DE_Sandra_reviewed_9_04.json?v=1712638888';
         if(maxLimitCartP) {
        maxLimitCartP.textContent = 'BESTELLWERT AUF 1500€ BEGRENZT';
         }
            break;
        case 'ru':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/RU_Alex_040424_full_c3955efc-1d94-4df1-9d8c-ae8c2780d49b.json?v=1712322526';
         if(maxLimitCartP) {
        maxLimitCartP.textContent = 'ЗАКАЗ НЕ БОЛЕЕ ЧЕМ НА 1500€';
         }
            break;
        case 'it':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/IT_Sandra_reviewed_9_04.json?v=1712638887';
         if(maxLimitCartP) {
        maxLimitCartP.textContent = "VALORE D'ORDINE LIMITATO A 1500€";
         }
            break;
        case 'zh':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/CN_Alex_040424_full_b1bdcc27-55a2-4300-9797-724167ed99d7.json?v=1712322527';
         if(maxLimitCartP) {
        maxLimitCartP.textContent = '订单金额限制为 1500 欧元';
         }
            break;
        default:
            break;
    }

    if (url) {
        const response = await fetch(url);
        const data = await response.json();
        TranslationDrawer(data);
        TranslationFormButtons(data);
      console.log('open -', data[8]["bottomP"]);
      console.log('url -', url);
    }
});
console.log('ooopen');
     
    setTimeout(() => {
      
    
    let allPromo = document.querySelectorAll('.promo-cod-text a');
    console.log('allPromoallPromo', allPromo);
          let lang = document.querySelector('.notVisible1-lang').textContent;
            console.log('langlang', lang);
          if (lang === 'zh-CN') {
            lang = 'zh';
          }
    
          let country = document.querySelector('.notVisible1-country').textContent;
          let myLocal = '/' + lang + '-' + country;
          if (myLocal === '/en-MC') {
            myLocal = '';
          } else if (country === 'MC') {
            myLocal = '/' + lang;
          }

          console.log('myLocal', myLocal);

          allPromo.forEach((url) => {
            console.log('urlurlurl', url);
            var href = url.getAttribute('href');
            var newHref = `${myLocal}` + href;
            console.log('newHref', newHref);
            url.href = newHref;
          
        });
    },1000);
if (typeof customerTax === 'function') {
  customerTax(); 
} else if (typeof notCustomerTax === 'function') {
  notCustomerTax();
}


    

  }

  

  close() {
      const headerTrueCount = document.querySelector('.headerTrueCountDrawer');
    console.log('headerTrueCount', headerTrueCount);
  const cartTime = setInterval(() => {
     
const testtt = document.querySelector('.header__cart .cart-count-bubble span');

  if (testtt) {
    testtt.textContent = headerTrueCount.textContent;
    if (cartTime) {
      setTimeout(() => {      
      
      clearInterval(cartTime);
        },4000);
    }
    
  }
});
    const headerTrueCount2 = document.querySelector('.headerTrueCountDrawer');
  const cartTime2 = setInterval(() => {
     
const testtt2 = document.querySelector('.headerTrueCount23');

  if (testtt2) {
    testtt2.textContent = headerTrueCount2.textContent;
    if (cartTime2) {
      setTimeout(() => {      
      
      clearInterval(cartTime2);
        },4000);
    }
    
  }
});
    console.log('close()');
    
    const cartDrawerPreloader2 = document.querySelector('.preloader2');
    const cartDrawerPreloader = document.querySelector('.cart-drawer-preloader');
     cartDrawerPreloader.style.display = 'none';
      cartDrawerPreloader2.style.zIndex = '0';
    cartDrawerPreloader.classList.remove('active');
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    
    document.querySelector('.drawer').style.backgroundColor = '#ffffff00';
    const htmlOver = document.querySelector('html');
    htmlOver.setAttribute('style', 'overflow: auto !important;');
  //   const sampleProducts = document.querySelectorAll('cart-drawer .SampleProduct'); 
  //   console.log('SampleProducts', sampleProducts);
  //   if (sampleProducts.length > 0) {
  //     // if клик на оверлаей то этот код а если на другое то второй код:
  //     const setInt = setInterval(() => {
              
  //     const headerCount = document.querySelectorAll('.header__cart-count span');
  //     if (headerCount.length > 2) {
  //       clearInterval(setInt);
  //     }
  //     headerCount[2].textContent = parseInt(headerCount[2].textContent) - sampleProducts.length;
        
  //       });
  //     setTimeout(() => {
  //         if (setInt) {
  //           clearInterval(setInt);
  //         }
          
  //       },1500);
  //     const setInt2 = setInterval(() => {
  //     const bubbleSpan = document.querySelector('.cart-count-bubble span');
  //       console.log('to Optimize');
  //       var inputs = document.querySelectorAll('.cart__quantity-input');
  // var hCounts = document.querySelectorAll('.header__cart-count'); // Используем querySelector
  //  console.log('hCounts', hCounts);
  // console.log('inputs', inputs);
  // var totalQuantity = 0; // Добавляем переменную для хранения общего количества
  // inputs.forEach(function(input) {
  //   var quantity = parseInt(input.value);
  //   if (!isNaN(quantity)) {
  //     totalQuantity += quantity; // Суммируем количество
  //   }
  // });
  // console.log('totalQuantity', totalQuantity);
  // hCounts.forEach((hCount) => {
    
  
  // hCount.textContent = totalQuantity; // Обновляем текстовое содержимое элемента
  // const hCo = setInterval(() => {
  //   hCount.textContent = totalQuantity;
  // });
  //   });
  // setTimeout(() => {
  //   clearInterval(hCo);
  // },2000);
  //     if (bubbleSpan) {
  //       clearInterval(setInt2);
      
  //     bubbleSpan.textContent = parseInt(bubbleSpan.textContent) - sampleProducts.length;
  //       bubbleSpan.style.display = 'block';
  //       }
  //       });
  //     setTimeout(() => {
  //         if (setInt2) {
  //           clearInterval(setInt2);
  //         }
          
  //       },1500);
        
      
  //   }
    realCount(); 
    const blackTest = document.querySelector('.black_test');
    blackTest.style.top = '100000';
  }
  

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

  }

  renderContents(parsedState) {
  
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
         sectionElement.innerHTML =
         this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this)); 
       this.querySelector('#CartDrawer-Overlay').addEventListener('click', () => {
         
         // let cartCountBubble = document.querySelector('.cart-count-bubble');
         
         //  cartCountBubble.classList.remove('cart-count-bubble');
         //  cartCountBubble.classList.add('header__cart-count');
         
       });  
      
        this.open();
       if (typeof customerTax === 'function') {
  customerTax(); 
} else if (typeof notCustomerTax === 'function') {
  notCustomerTax();
}

      
    
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function cartPoints() {
    const mlp = document.querySelector('.Mcart-points');
    const plp = document.querySelector('.cart-points');
      
    plp.style.display = 'block';
    mlp.style.display = 'none';
    const pTotals = document.querySelector('body .cart-drawer .totals');
    let height = 250;
    const finalHeight = 295;

    const intervalId = setInterval(() => {
      if (height < finalHeight) {
        height += 1;
        pTotals.setAttribute('style', 'height: ' + height + 'px !important;');
      } else {
        clearInterval(intervalId);
      }
    }, 10);
}
  document.addEventListener('DOMContentLoaded', async () => {
    const autoRemoveButton5 = document.querySelectorAll('.autoRemoveButton5');
    
    for (const removeB of autoRemoveButton5) {
        removeB.click();

        await new Promise(resolve => setTimeout(resolve, 500));
    }
});

  function deleteBlackTest() {
    const blackTest = document.querySelectorAll('.black_test');
    blackTest.forEach((overlay) => {
      overlay.style.top = '100000px';
    });
    
  }
